export default __webpack_public_path__ + "static/media/fhp-badge.21641d40.jpg";